import {handleActions} from 'redux-actions';
import actions from './confirmation.actions';

const DEFAULT_STATE = {
	data: null,
	title: null,
	message: null,
	buttons: ['confirm', 'cancel'],
	onYes: null,
	onNo: null,
	onContinue: null,
	onLater: null,
	onConfirm: null,
	onCancel: null
};

const reducer = handleActions(
	{
		[actions.confirmationOpen]: (state, {payload}) => ({
			...DEFAULT_STATE,
			...payload
		}),
		[actions.confirmationClose]: () => ({
			...DEFAULT_STATE
		})
	},
	{
		...DEFAULT_STATE
	}
);

export default reducer;



// WEBPACK FOOTER //
// ./src/widgets/confirmation.reducer.js